import React, { useState, useEffect } from "react";
import Select from 'react-select';
import Carousel from 'react-multi-carousel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router, Route, Routes, useNavigate, useParams, useSearchParams } from "react-router";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import BookViewer from "./BookViewer.jsx";
import {
  apiLogin,
  apiSuggestions,
  apiOneBook,
  apiForgotPassword,
  apiSignup,
  apiUser,
  apiTags,
  apiSearch,
  adminUploadNewBook,
  adminCreateTag,
  adminAssociateTags,
  URL_BASE,
} from "./requests.js";
import signUpLogo from './assets/MatingPress-Logo_Submark-No-Name-13-OnDark.svg';
import textLogoWhite from './assets/MatingPress-Logo_Primary-3-White.svg';
import loginLogo from './assets/MatingPress-Logo_Submark-With-Name-9-OnDark.svg';
import headerBarLogo from './assets/MatingPress-Logo_Submark-No-Name-13-OnDark.svg';

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error parsing JWT:", error);
    return null;
  }
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const throb = keyframes`
  from {
    width: 173px;
    height: 200px;
  }
  to {
    width: 200px;
    height: 230px;
  }
`;

const responsive = {
  all: {
    breakpoint: { max: 9999999, min: 465 },
    items: 4
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  },
};

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: FreeMono, monospace;
    background-color: #1f1f1f;
  }
`;

const Container = styled.div`
  padding: 20px;
`;

const LoginWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const Input = styled.input`
  margin: 10px 0;
  padding: 10px;
  width: 200px;
  animation: ${fadeIn} 1s ease-in-out forwards;
  font-family: FreeMono, monospace;
  &::placeholder {
    font-family: FreeMono, monospace;
  }
`;

const SubmitButton = styled.input`
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  animation: ${fadeIn} 1s ease-in-out forwards;
  font-family: FreeMono, monospace;

  &:hover {
    background-color: #0056b3;
  }
`;

const HighlightedThumbnail = styled.div`
  background-color: red;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: center;
  width: min-content;
`;

const Thumbnail = styled.div`
  background-color: #1f1f1f;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: center;
  width: min-content;
`;

const TitleText = styled.div`
  width: 250px;
  max-width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #888;
`

const DetailBox = styled.div`
  background-color: #1f1f1f;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin: auto;
`;

const Subtext = styled.div`
  width: 220px;
  display: flex;
`;

const NewUserLink = styled.a`
  color: #999;
  text-decoration: none;
  font-size: 11px;
  padding-top: 10px;
  flex-grow: 3;
  width: 44px;
  &:hover {
    color: #333;
    text-decoration: none;
  }
`; 

const ForgotPasswordLink = styled.a`
  color: #999;
  text-decoration: none;
  font-size: 11px;
  padding-top: 10px;
  width: 180px;
  &:hover {
    color: #333;
    text-decoration: none;
  }
`;

const ErrorMsg = styled.div`
  color:rgba(170, 0, 0, 1);
  font-size: 11px;
  padding-top: 10px;
`;

const SuccessMsg = styled.div`
  color: #777;
  font-size: 11px;
  padding-top: 10px;
`;

const AnimatedEaseInImage = styled.img`
  animation: ${fadeIn} 1s ease-in-out forwards;
  margin-bottom: 10px;
`;

const HeartThrobImage = styled.img`
  animation: ${throb} 1s ease-in-out forwards;
  animation-duration: infinite;
  margin-bottom: 10px;
`

const ConfirmAgeButtons = styled.div`
  width: 50%;
  display: flex;
`;

const ConfirmAgeButton = styled.div`
  width: 150px;
  color: #FFF;
  background-color: #007bff;
  border-radius: 3px;
  height: 30px;
  text-align:center;
  padding-top: 9px;
  animation: ${fadeIn} 1s ease-in-out forwards;
  &:hover {
    background-color: #BBB;
    cursor: pointer;
  }
`;

const LegalText = styled.h3`
  animation: ${fadeIn} 1s ease-in-out forwards;
  width: 50%;
  color: #888;
`;

const ConsentSplashScreen = () => {
  const setCookieTrue = () => {
    document.cookie = 'MATINGPRESSAGECONSENT=true;'
    window.location.reload();
  }

  const goAway = () => {
    window.location.href = 'https://www.youtube.com/watch?v=XqZsoesa55w&list=RDXqZsoesa55w&start_radio=1&t=28s';
  }
  return (
      <LoginWrapper>
        <div style={{width: '50%'}}>
          <AnimatedEaseInImage src={textLogoWhite} alt='Logo'/>
        </div>
        <LegalText>By using our site, you confirm that you are over 18 years of age, or the age of majority in your jurisdiction, and that you consent to viewing material of an adult nature.</LegalText>
        <LegalText>If you do not agree or are not legally allowed to access adult content, click "Leave Now", below.</LegalText>
        <ConfirmAgeButtons style={{justifyContent: 'space-between'}}>
          <ConfirmAgeButton onClick={goAway}>Leave Now</ConfirmAgeButton>
          <ConfirmAgeButton onClick={setCookieTrue}>Confirm</ConfirmAgeButton>
        </ConfirmAgeButtons>
      </LoginWrapper>
    );
}
const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const onLogin = async (username, password, setError) => {
    const { status, body } = await apiLogin(username.toLowerCase(), password);
    if (status === 200) {
      navigate("/")
      return;
    }
    setError(body);
  };

  return (
    <LoginWrapper onSubmit={(event) => {
      event.preventDefault();
      onLogin(username, password, setError);
    }}>
    <AnimatedEaseInImage src={loginLogo} alt='Login' width={120} height={167} />
    <Input placeholder="Email" value={username} onChange={(e) => setUsername(e.target.value)} />
    <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
    <SubmitButton type="submit" value="Login" />
    <Subtext>
      <ForgotPasswordLink href="/forgot">Forgot?</ForgotPasswordLink>
      <NewUserLink href="/signup">Sign up</NewUserLink>
    </Subtext>
    {error && <ErrorMsg>{error}</ErrorMsg>}
  </LoginWrapper>
  );
};

const ForgotPassword = ({ onSubmit }) => {
  const [email, setEmail] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  return (
    <LoginWrapper onSubmit={(event) => {
        event.preventDefault();
        if (email) {
          onSubmit(email, setEmail, setError, setSuccess);
        }
      }}>
      <MainMenuText>Forgot Your Password?</MainMenuText>
      <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <SubmitButton type="submit" />
      <Subtext>
        <ForgotPasswordLink href="/">Go Back</ForgotPasswordLink>
      </Subtext>
      {success && <SuccessMsg>{success}</SuccessMsg>}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </LoginWrapper>
  );
};

const Signup = ({ onSubmit }) => {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordConfirm, setPasswordConfirm] = useState(null);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  return (
    <LoginWrapper onSubmit={(event) => {
        event.preventDefault();
        if (username && password && passwordConfirm) {
          onSubmit(username, password, passwordConfirm, setError, setSuccess);
        }
      }}>
      <HeartThrobImage src={signUpLogo} alt='Logo' width={173} height={200}/>
      <MainMenuText>Sign Up</MainMenuText>
      <Input placeholder="Email" value={username} onChange={(e) => setUsername(e.target.value)} />
      <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <Input type="password" placeholder="Confirm Password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
      <SubmitButton type="submit" value="Sign Up" />
      <Subtext>
        <ForgotPasswordLink href="/">Go Back</ForgotPasswordLink>
      </Subtext>
      {success && <SuccessMsg>{success}</SuccessMsg>}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </LoginWrapper>
  );
};

const StyledHeader = styled.header`
  color: #EEE;
  background-color: #0d0d0d;
  width: 100%;
  height: 50px;
  padding-top: 0px;
  display: flex;
`;

const NavItem = styled.a`
  padding-top: 16px;
  padding-left: 10px;
  padding-right: 10px;
  text-decoration: none;
  color: rgba(188, 0, 45, 255);
  &:hover {
    background-color: #444;
  }
`

const LogoBox = styled.div`
  flex-basis: 50px;
  width: 100%;
  padding-left: 0px;
  padding-top: 10px;
  &:hover {
    background-color: #444;
  }
`

const Gap = styled.div`
  flex-basis: 75%;
`

const UserPill = styled.a`
  color: rgba(188, 0, 45, 255);
  font-family: FreeMono, monospace;
  padding-top: 11px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 24px;
  text-decoration: none;
  &:hover {
    background-color: #444;
  }
`;

const MainMenuText = styled.h2`
  color: #888;
`;

const HeaderBar = ({username, isAdmin}) => {
  const userPillHref = username ? "/settings" : "/login";
  return (
    <StyledHeader>
      {/* Logo Area */}
      <LogoBox>
        <NavItem href="/">
          <img alt='logo' src={headerBarLogo} width={26} height={30}/>
        </NavItem>
      </LogoBox>

      {/* Spacer for additional items if needed */}
      <NavItem href="/search">Search</NavItem>
      <NavItem href="/tags">Tags</NavItem>
      {isAdmin && <NavItem href="/admin">Admin</NavItem>}

      <Gap/>
      <UserPill href={userPillHref}>{username ? username.substring(0, 2) : 'Login'}</UserPill>
    </StyledHeader>
  )
};
const getThumbUrl = (bookData) => 
  `${URL_BASE}/api/books?book_id=${bookData.book_id || bookData.id}&page=0`;

const Home = ({isAdmin}) => {
  const navigate = useNavigate();
  const [forYou, updateForYou] = useState(null);
  const [popularNow, updatePopularNow] = useState(null);
  const [newArrivals, updateNewArrivals] = useState(null);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState(null);
  
  useEffect(() => {
    const fetchSuggestions = async () => {
      const { status, body } = await apiSuggestions();
      if (status === 200) {
        updateForYou(body);
        updatePopularNow(body);
        updateNewArrivals(body);
        return;
      }
      setError(body);
    };
    fetchSuggestions().catch(console.error);
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);
  
  return (
    <>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <Container>
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {false && <>
      <MainMenuText>For You</MainMenuText>
      <Carousel
          responsive={responsive}
          arrows
          swipeable={false}
          draggable={false}
          showDots={false}
          infinite
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >
          {forYou.map((item) => (
            <Thumbnail key={item.book_id} onClick={() => navigate(`/book/${item.book_id}/summary`)}>
              <img src={getThumbUrl(item)} alt={item.title} width={250} height={353}/>
              <TitleText>{item.title}</TitleText>
            </Thumbnail>
          ))}
        </Carousel>
      </>}
      {popularNow && <>
      <MainMenuText>Popular Now</MainMenuText>
      <Carousel
          responsive={responsive}
          arrows
          swipeable={false}
          draggable={false}
          showDots={false}
          infinite
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
        >
          {popularNow.map((item) => (
            <Thumbnail key={item.book_id} onClick={() => navigate(`/book/${item.book_id}/summary`)}>
              <img src={getThumbUrl(item)} alt={item.title} width={250} height={353}/>
              <TitleText>{item.title}</TitleText>
            </Thumbnail>
          ))}
        </Carousel>
      </>}
      {false && <>
      <MainMenuText>New Arrivals</MainMenuText>
      <Carousel
          responsive={responsive}
          arrows
          swipeable={false}
          draggable={false}
          showDots={false}
          infinite
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
          // removeArrowOnDeviceType={["tablet", "mobile"]}
        >
          {newArrivals.map((item) => (
            <Thumbnail key={item.book_id} onClick={() => navigate(`/book/${item.book_id}/summary`)}>
              <img src={getThumbUrl(item)} alt={item.title} width={250} height={353}/>
              <TitleText>{item.title}</TitleText>
            </Thumbnail>
          ))}
        </Carousel>
      </>}
    </Container>
    </>
  );
};

const SummaryContainer = styled.div`
  display: flex;
  gap: 20px;
  padding: 20px;
  max-width: 900px;
  margin: 8px auto;
  align-items: flex-start;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #aaa;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const CoverContainer = styled.div`
  flex: 0 0 250px;

  @media (max-width: 768px) {
    flex: none;
    width: 60%;
  }
`;

const CoverImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const InfoContainer = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    margin-top: 15px;
  }
`;

const Title = styled.h1`
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  color: #333;
`;

const Text = styled.p`
  margin: 5px 0;
  font-size: 1rem;
  color: #555;
`;

const ReadButton = styled.a`
  display: inline-block;
  margin-top: 15px;
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #0056b3;
  }
`;

const BookDetail = ({ 
  coverImage, 
  title, 
  author, 
  publicationDate, 
  uploadDate, 
  readLink 
}) => {
  return (
    <>
      <CoverContainer>
        <CoverImage src={coverImage} alt={`${title} cover`} />
      </CoverContainer>

      <InfoContainer>
        <Title>{title}</Title>
        <Text><strong>Author:</strong> {author}</Text>
        <Text><strong>Publication Date:</strong> {publicationDate}</Text>
        <Text><strong>Upload Date:</strong> {uploadDate}</Text>
        <ReadButton href={readLink}>Read</ReadButton>
      </InfoContainer>
    </>
  );
};

const BookSummary = ({isAdmin}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bookData, updateBookData] = useState(null);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    const fetchBook = async () => {
      const { status, body } = await apiOneBook(id);
      if (status === 200) {
        updateBookData(body);
        return;
      }
      setError(body);
    };
    fetchBook().catch(console.error);
  }, [id]);

  if (bookData) {
    console.log(bookData);
  }

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);

  return (<>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <SummaryContainer>
      {bookData && <BookDetail
        coverImage={getThumbUrl(bookData)}
        title={bookData.title}
        author="Anon Anon"
        readLink={`/book/${bookData.id}/1`}
      />}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </SummaryContainer>
  </>);
}

const Detail = ({isAdmin}) => {
  const { id, page } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!page)
      navigate(`/book/${id}/1`, { replace: true });
  });
  const [bookData, updateBookData] = useState(null);
  const [error, setError] = useState(null);
  const [imgUrls, setImgUrls] = useState([]);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    const fetchBook = async () => {
      const { status, body } = await apiOneBook(id);
      if (status === 200) {
        updateBookData(body);
        return;
      }
      setError(body);
    };
    fetchBook().catch(console.error);
  }, [id]);

  useEffect(() => {
    if (bookData !== null && bookData !== undefined) {
      const urls = [];
      for(let i = 1; i <= bookData.page_count; i++) {
        urls.push(
          `${URL_BASE}/api/books?book_id=${id}&page=${i}`
        );
      }
      setImgUrls(urls);
    }
  }, [bookData, id]);

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);

  return (<>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <Container>
      {bookData &&
      <DetailBox>
        <MainMenuText>{bookData.title}</MainMenuText>
        {imgUrls && <BookViewer username={username} imgUrls={imgUrls} page={page} />}
        {error && <ErrorMsg>{error}</ErrorMsg>}
      </DetailBox>}
    </Container>
  </>);
};

const TagResults = styled.div`
  display: flex;
`;

const TagResultsColumn = styled.div`
  flex-basis: 25%;
`;

const TagPill = styled.div`
  width: 50%;
  background-color: #333;
  padding: 5px 5px 5px 5px;
  text-align: center;
  color: #eee;
  margin-bottom: 5px;
  border-radius: 3px;
  user-select: none;
    &:hover {
    color: #aaa;
    cursor: pointer;
  }
`;

const TagsHeaderLine = styled.div`
  display: flex;
  width: 66%;
  justify-content: space-between;
  font-size: 20px;
  padding-bottom: 20px;
  font-weight: bold;
  color: #888;
`;

const PageNum = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  &:hover {
    color: #aaa;
    cursor: pointer;
  } 
`;

const PageNumSelected = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  color: #a00;
  &:hover {
    color: #a00;
    cursor: pointer;
  } 
`;

const Tags = ({isAdmin}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [username, setUsername] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [tags, setTags] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!searchParams.has('page')) {
      setSearchParams((prev) => {
        prev.set('page', '1');
        return prev;
      });
    }
    if (!searchParams.has('q')) {
      setSearchParams((prev) => {
        prev.set('q', '');
        return prev;
      });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);

  useEffect(() => {
    const fetchTags = async (q) => {
      const { status, body } = await apiTags(undefined, undefined, q, searchParams.get('page'));
      if (status === 200) {
        setTags(body.data);
        setTotalPages(body.page_count);
        setSearchParams(prev => {
          if (body.current_page > body.page_count) {
            prev.set('page', '1');
          } else {
            prev.set('page', body.current_page);
          }
          return prev;
        });
        return;
      }
      setError(body);
    };

    if (searchParams.get('q').length >= 3) {
      fetchTags(searchParams.get('q')).catch(console.error);
    } else {
      fetchTags('').catch(console.error);
    }
  }, [searchParams, setSearchParams]);

  function chunkArray(array, size) {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
  }

  const showPageNums = (totalPages) => {
    let children = [<div key={0}>Pages</div>]
    for (let i = 1; i <= totalPages; i++) {
      if (i === parseInt(searchParams.get('page'), 10)) {
        children.push(<PageNumSelected key={i} onClick={() => {
          setSearchParams((prev) => { prev.set('page', i); return prev; });
        }}>{i}</PageNumSelected>);
      } else {
        children.push(<PageNum key={i} onClick={() => {
          setSearchParams((prev) => { prev.set('page', i); return prev; });
        }}>{i}</PageNum>);
      }
    }
    return children;
  };

  const displayTags = (tags) => {
    const arrayChunks = chunkArray(tags, 13);
    const searchQuery = searchParams.get('q');
    return (<>
      <TagsHeaderLine>
        {searchQuery && searchQuery.length > 2 ? `Tags matching '${searchQuery}'` : 'All Tags'}
        {totalPages > 1 ? showPageNums(totalPages) : null}
      </TagsHeaderLine>
      <TagResults>
        {arrayChunks.map((tagChunk, idx) => {
          return (
          <TagResultsColumn key={idx}>
            {tagChunk.map(tag => <TagPill key={tag.name} title={tag.description} onClick={() => navigate(`/search?tags=${tag.name}&go=true`)}>{tag.name}</TagPill>)}
          </TagResultsColumn>
          );
        })}
      </TagResults>
    </>);
  };

  return (<>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <Container>
      <Input placeholder="Search..." value={searchParams.get('q')} onChange={
        (e) => setSearchParams((prev) => { prev.set('q', e.target.value); return prev; })
      } />
      {tags && displayTags(tags)}
      {tags && tags.length === 0 && <h2>No Results...</h2>}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </Container>
  </>);
};

const SearchTerms = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainSearch = styled.div`
  display: flex;
  justify-content: space-between;
  width: 45%;
  height: 60px;
`;

const SearchButton = styled.div`
  max-width: 100px;
  background-color: #333;
  padding: 5px 5px 5px 5px;
  text-align: center;
  color: #eee;
  margin-bottom: 5px;
  border-radius: 3px;
  user-select: none;
    &:hover {
    color: #aaa;
    cursor: pointer;
  }
`;

const RelativeContainer = styled.div`
  position: relative;
`;

const StyledDatePicker = styled(DatePicker)`
  margin: 10px 0;
  padding: 10px;
  width: 200px;
  font-family: FreeMono, monospace;
  &::placeholder {
    font-family: FreeMono, monospace;
  }
`;

const Search = ({isAdmin}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [unfolded, setUnfolded] = useState(false);
  const [username, setUsername] = useState(null);
  const [results, setResults] = useState(null);
  const [tagResults, setTagResults] = useState([]);
  const [publishedAfter, setPublished] = useState(null);
  const [uploadedAfter, setUploaded] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!searchParams.has('q')) {
      setSearchParams((prev) => {
        prev.set('q', '');
        return prev;
      });
    }
    if (!searchParams.has('author')) {
      setSearchParams((prev) => {
        prev.set('author', '');
        return prev;
      });
    }
    if (!searchParams.has('pub')) {
      setSearchParams((prev) => {
        prev.delete('pub');
        return prev;
      });
    }
    if (!searchParams.has('upl')) {
      setSearchParams((prev) => {
        prev.delete('upl');
        return prev;
      });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);

  useEffect(() => {
    if (searchParams.has('upl') || searchParams.has('pub') || searchParams.has('author')) {
      if (searchParams.get('upl') || searchParams.get('pub') || searchParams.get('author')) {
        setUnfolded(true);
      }
    }
  }, []);

  const executeSearch = () => {
    const search = async (params) => {
      const { status, body } = await apiSearch(params);
      if (status === 200) {
        setResults(body.data);
        setError(null);
        return;
      }
      setError(body.status);
    };

    search(Object.fromEntries(searchParams)).catch(console.error);
  };

  const executeTagSearch = () => {
    const getTags = async () => {
      const { status, body } = await apiTags(undefined, undefined, '', 1, 500);
      if (status === 200) {
        setTagResults(body.data);
        setError(null);
        return;
      }
      setError(body.status);    
    }

    getTags().catch(console.error);
  }

  useEffect(() => {
    if (searchParams.has('go')) {
      executeSearch();
    }
  }, []);

  useEffect(() => {
    executeTagSearch();
  }, []);

  const showResults = (results) => {
    if (results.length === 0) {
      return <MainMenuText>No Results</MainMenuText>;
    }
    return (<>
      <Carousel
          responsive={responsive}
          arrows
          swipeable={false}
          draggable={false}
          showDots={false}
          customTransition="transform 0ms linear"
          transitionDuration={100}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
          removeArrowOnDeviceType={["tablet", "mobile"]}
        >
        {results.map((item) => {
          return (
            <Thumbnail key={item.book_id} onClick={() => navigate(`/book/${item.book_id}`)}>
              <img src={getThumbUrl(item)} alt={item.title} width={250} height={353}/>
              <TitleText>{item.title}</TitleText>
            </Thumbnail>
          );
        })}
        </Carousel>
    </>);
  };

  function formatDate(date) {
    if (!date) {
      return '1970-01-01';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const parseTagsFromSearch = (searchParams) => {
    if (searchParams.has('tags')) {
      if (searchParams.get('tags')) {
        const values = searchParams.get('tags').split(',').map(t => ({value: t, label: t}));
        return values;
      }
    }
    return null;
  }

  const customStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      marginTop: '10px',
      marginBottom: 0,
      borderRadius: 0,
      fontSize: '13px',
      width: '200px',
      borderColor: '#777',
      overflowX: 'auto',
    }),
    option: (provided) => ({
      ...provided,
      borderRadius: 0,
      fontSize: '13px',
      width: '180px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 0,
      fontSize: '13px',
      width: '200px',
      overflowX: 'hidden',
    }),
  };

  return (<>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <Container>
      <SearchTerms key="searchterms">
        <MainSearch key="mainsearch">
          <Input key="title" placeholder="Title..." value={searchParams.get('q') || ''} onChange={
            (e) => setSearchParams((prev) => { prev.set('q', e.target.value); return prev; })
          } />
          {tagResults &&
            <Select
              key="tags"
              placeholder="Tags..."
              defaultValue={parseTagsFromSearch(searchParams)}
              isMulti
              name="tags"
              styles={customStyles}
              options={tagResults.map(t => ({value: t.name, label: t.name}))}
              onChange={
                (selectedTags) => setSearchParams((prev) => {
                  prev.set('tags', selectedTags.map(t => t.value).join(",")); return prev;
                })
              }
            />
          }
        </MainSearch>
        {unfolded ?
          (<>
          <Input key="author" placeholder="Author..." value={searchParams.get('author') || ''} onChange={
            (e) => setSearchParams((prev) => { prev.set('author', e.target.value); return prev; })
          } />
          <RelativeContainer>
            <StyledDatePicker
              selected={publishedAfter}
              placeholderText="Published after..."
              onChange={(date) => {
                setSearchParams((prev) => { prev.set('pub', formatDate(date)); return prev; });
                setPublished(date);
              }}
            />
          </RelativeContainer>
          <RelativeContainer>
            <StyledDatePicker
              selected={uploadedAfter}
              placeholderText="Uploaded after..."
              onChange={(date) => {
                setSearchParams((prev) => { prev.set('upl', formatDate(date)); return prev; });
                setUploaded(date);
              }}
            />
          </RelativeContainer>
          <SearchButton key="hide" onClick={() => setUnfolded(false)}>Hide</SearchButton></>)
          : <SearchButton key="advanced" onClick={() => setUnfolded(true)}>Advanced</SearchButton>
        }
        <SearchButton key="executesearch" onClick={() => executeSearch()}>Search</SearchButton>
      </SearchTerms>
      {results && showResults(results)}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </Container>
  </>);
};

const AssociateTags = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [tagResults, setTagResults] = useState([]);
  const [error, setError] = useState(null);
  const [selectedBook, setSelectedBook] = useState(null);
  const [selectedTags, setSelectedTags] = useState(null);
  const [associateTagResult, setAssociateTagResult] = useState(null);

  const executeSearch = () => {
    const search = async (q) => {
      const { status, body } = await apiSearch({q});
      if (status === 200) {
        setResults(body.data);
        setError(null);
        return;
      }
      setError(body.status);
    };
    search(query).catch(console.error);
  };

  const executeTagSearch = () => {
    const getTags = async () => {
      const { status, body } = await apiTags(undefined, undefined, '', 1, 500);
      if (status === 200) {
        setTagResults(body.data);
        setError(null);
        return;
      }
      setError(body.status);    
    }

    getTags().catch(console.error);
  }

  useEffect(() => {
    executeTagSearch();
  }, []);

  const handleAssociateTag = async () => {
    console.log(selectedTags, selectedBook);
    const r = await adminAssociateTags(selectedTags, selectedBook);
    setAssociateTagResult(r.body);
  }

  const showResults = (results) => {
    if (results.length === 0) {
      return <MainMenuText>No Results</MainMenuText>;
    }
    return (<>
      <Carousel
          responsive={responsive}
          arrows
          swipeable={false}
          draggable={false}
          showDots={false}
          customTransition="transform 0ms linear"
          transitionDuration={100}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
          removeArrowOnDeviceType={["tablet", "mobile"]}
        >
        {results.map((item) => {
          const ThumbComponent = selectedBook === item.book_id ? HighlightedThumbnail : Thumbnail
          return (
            <ThumbComponent key={item.book_id} onClick={() => {
              if (selectedBook !== item.book_id)
                setSelectedBook(item.book_id);
              else {
                setSelectedBook(null);
              }
            }}>
              <img src={getThumbUrl(item)} alt={item.title} width={250} height={353}/>
              <TitleText>{item.title}</TitleText>
            </ThumbComponent>
          );
        })}
        </Carousel>
    </>);
  }

  const customStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      marginTop: '10px',
      marginBottom: 0,
      borderRadius: 0,
      fontSize: '13px',
      width: '200px',
      borderColor: '#777',
      overflowX: 'auto',
    }),
    option: (provided) => ({
      ...provided,
      borderRadius: 0,
      fontSize: '13px',
      width: '180px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 0,
      fontSize: '13px',
      width: '200px',
      overflowX: 'hidden',
    }),
  };

  return (<>
    <Container>
      <SearchTerms key="searchterms">
        <MainSearch key="mainsearch">
          <Input key="title" placeholder="Title..." value={query} onChange={
            (e) => setQuery(e.target.value)
          } />
          {tagResults &&
            <Select
              key="tags"
              placeholder="Tags..."
              isMulti
              name="tags"
              styles={customStyles}
              options={tagResults.map(t => ({value: t.name, label: t.name}))}
              onChange={
                (selectedTags) => setSelectedTags(selectedTags.map(t => t.value))
              }
            />
          }
        </MainSearch>
        <SearchButton key="executesearch" onClick={() => executeSearch()}>Search</SearchButton>
      </SearchTerms>
      {selectedBook && selectedTags && <button 
        onClick={() => handleAssociateTag()}
        className="submit"
        >Associate</button>
      }
      {results && showResults(results)}
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {associateTagResult && <div>Success</div>}
    </Container>
  </>);
};

const Admin = ({isAdmin}) => {
  const [username, setUsername] = useState(null);
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [tagName, setTagName] = useState('');
  const [tagDescription, setTagDescription] = useState('');
  const [tagCreateResult, setTagCreateResult] = useState(null);


  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const { status, body } = await apiUser();
      if (status === 200) {
        setUsername(body.username);
      } else {
        setUsername(null);
      }
    };
    fetchUser().catch(console.error);
  }, []);

  const handleUpload = async () => {
    const r = await adminUploadNewBook(file);
    setResult(r);
  }

  const handleCreateTag = async () => {
    if (tagName && tagName.length > 0) {
      const r = await adminCreateTag(tagName, tagDescription);
      setTagCreateResult(r.body);
    }
  }



  return (<>
    <HeaderBar username={username} isAdmin={isAdmin}/>
    <MainMenuText>Upload New Content</MainMenuText>
    <div className="input-group">
      <input id="file" type="file" onChange={handleFileChange} />
    </div>
    {file && (
      <section>
        File details:
        <ul>
          <li>Name: {file.name}</li>
          <li>Type: {file.type}</li>
          <li>Size: {file.size} bytes</li>
        </ul>
      </section>
    )}

    {file && file.type.includes('zip') && (
      <button 
        onClick={() => handleUpload()}
        className="submit"
      >Upload</button>
    )}
    {file && (
      <button 
        onClick={() => setFile(null)}
        className="submit"
      >Clear</button>
    )}
    {
      file && !file.type.includes('zip') && <div>Not a ZIP file...</div>
    }
    {error && <ErrorMsg>{error}</ErrorMsg>}
    {result && <div>{result}</div>}
    <MainMenuText>Create New Tag</MainMenuText>
    <Input placeholder="Name..." value={tagName} onChange={(e) => setTagName(e.target.value)} />
    <Input placeholder="Description..." value={tagDescription} onChange={(e) => setTagDescription(e.target.value)} />
    <button 
      onClick={() => handleCreateTag()}
      className="submit"
    >Create</button>
    {tagCreateResult && <div>{tagCreateResult}</div>}
    <MainMenuText>Associate Tags to Book</MainMenuText>
    <AssociateTags />
    {/* <Input placeholder="Search Book..." value={book} onChange={(e) => setTagName(e.target.value)} />
    <Input placeholder="Description..." value={tagDescription} onChange={(e) => setTagDescription(e.target.value)} />
    <button 
      onClick={() => handleCreateTag()}
      className="submit"
    >Create</button> */}
  </>)
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const App = () => {
  const claimsJwt = parseJwt(getCookie('MATINGPRESSTOKEN'));

  const handleReset = async (email, setEmail, setError, setSuccess) => {
    const { status, body } = await apiForgotPassword(email);
    if (status === 200) {
      setSuccess(body);
      setError(null);
      setEmail(null);
      return;
    }
    setSuccess(null);
    setError(body);
    setEmail(null);
  }

  const handleSignup = async (username, password, passwordConfirm, setError, setSuccess) => {
    const { status, body } = await apiSignup(
      username,
      password,
      passwordConfirm,
    );
    console.log(status, body);
    if (status === 201) {
      setSuccess(body);
      setError(null);
      return;
    }
    setSuccess(null);
    setError(body);
  }

  const isAdmin = claimsJwt && claimsJwt.data && claimsJwt.data.subscription_tier === 'god';
  const consented = getCookie('MATINGPRESSAGECONSENT') === 'true';
  return (
    <Router>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={(consented ? <Home isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/search" element={(consented ? <Search isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/tags" element={(consented ? <Tags isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/book/:id/summary" element={(consented ? <BookSummary isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/book/:id" element={(consented ? <Detail isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/book/:id/:page" element={(consented ? <Detail isAdmin={isAdmin}/> : <ConsentSplashScreen />)} />
        <Route path="/login" element={(consented ? <Login /> : <ConsentSplashScreen />)} />
        <Route path="/forgot" element={(consented ? <ForgotPassword onSubmit={handleReset} /> : <ConsentSplashScreen />)} />
        <Route path="/signup" element={(consented ? <Signup onSubmit={handleSignup} /> : <ConsentSplashScreen />)} />
        {isAdmin ?
          <>
            <Route path="/admin" element={<Admin isAdmin={isAdmin}/>} />
          </> : null
        }
      </Routes>
    </Router>
  );
};

export default App;
